/* global console */

console.log("Index file loaded");
